var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFace4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_2823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15313 5.30191C2.22915 7.83946 1.47725 11.163 1.07918 14.3967C0.747462 17.1138 0.636889 19.9209 1.43302 22.5258C2.6051 26.3658 5.70116 29.3075 9.2174 30.7447C12.7336 32.1819 16.6258 32.2493 20.3411 31.6205C26.9534 30.5202 32.4379 24.21 32.7917 16.9791C33.3446 6.37981 23.592 -1.07563 14.348 0.137001C10.5222 0.631036 6.56363 2.09069 4.15313 5.30191Z",
    fill: "#FBE250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0014 5.16618C24.763 2.38162 20.4727 1.25881 17.8853 1.68548C17.4872 1.75285 17.642 2.33671 17.9737 2.38162C19.4996 2.58373 20.8486 2.87566 22.2419 3.61671C23.3918 4.22303 24.2101 5.27846 25.3379 5.88478C25.8023 6.1318 26.2225 5.63776 26.0014 5.16618Z",
    fill: "#FFE175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0425 6.60443C26.7108 6.55952 26.556 7.05355 26.7772 7.27812C27.2195 7.72724 27.7281 8.08654 28.1262 8.60303C28.5463 9.16443 28.7896 9.83812 29.2098 10.3995C29.4752 10.7588 29.9617 10.4444 29.9838 10.0627C30.0944 8.49075 28.4137 6.76162 27.0204 6.60443H27.0425Z",
    fill: "#FFE175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7173 16.6188C19.5894 17.7191 18.8596 18.5724 17.1568 18.6398C15.3655 18.7296 13.729 18.056 12.5791 16.6861C12.3137 16.3493 11.8714 16.776 12.0262 17.1128C13.5079 20.3914 20.4298 21.0426 21.3807 17.0005C21.4692 16.6188 21.0048 16.3268 20.7173 16.6188Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54102 11.4273C6.54102 11.6968 6.89485 11.7866 7.02754 11.562C7.64675 10.6189 8.00059 9.74308 9.26113 9.58589C10.4332 9.4287 11.2515 10.3719 11.5611 11.4273C11.738 12.0336 12.5562 11.7641 12.4678 11.1803C11.8928 7.7894 6.60736 7.90168 6.54102 11.4497V11.4273Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6209 11.4273C26.6209 11.6968 26.2671 11.7866 26.1344 11.562C25.5152 10.6189 25.1613 9.74308 23.9008 9.58589C22.7287 9.4287 21.9105 10.3719 21.6009 11.4273C21.4239 12.0336 20.6057 11.7641 20.6942 11.1803C21.2691 7.7894 26.5546 7.90168 26.6209 11.4497V11.4273Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5034 16.1477C24.9324 16.1477 26.0909 15.3434 26.0909 14.3512C26.0909 13.359 24.9324 12.5547 23.5034 12.5547C22.0744 12.5547 20.916 13.359 20.916 14.3512C20.916 15.3434 22.0744 16.1477 23.5034 16.1477Z",
    fill: "#F59186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2124 16.1477C11.6414 16.1477 12.7998 15.3434 12.7998 14.3512C12.7998 13.359 11.6414 12.5547 10.2124 12.5547C8.78343 12.5547 7.625 13.359 7.625 14.3512C7.625 15.3434 8.78343 16.1477 10.2124 16.1477Z",
    fill: "#F59186"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_2823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFace4);
export default __webpack_public_path__ + "static/media/icon-face-4.7a88f520c7eb9b1e9af50b27c6f4f967.svg";
export { ForwardRef as ReactComponent };